import React, { useCallback, useState, useRef } from "react";

import { useDropzone } from "react-dropzone";
import { useParams, Link } from "react-router-dom";

import { toast } from "react-toastify";

// import { uuid } from "uuid";
import { storage, firestore, auth } from "../firebase";
import {
  addDoc,
  arrayUnion,
  collection,
  serverTimestamp,
  updateDoc,
  doc,
} from "firebase/firestore";
import { ref, getDownloadURL, uploadBytes } from "@firebase/storage";

import {
  Box,
  Grid,
  Button,
  Typography,
  CircularProgress,
  TextField,
} from "@mui/material";

import { uploadFromBlobAsync } from "./Storage";

// const formHandler = (e) => {
//   e.preventDefault();
//   const file = e.target[0].files[0];
//   UploadFiles3(file);
//   // createPost(); // 👈 don't call this here
// };

const UploadFiles3 = ({ siteRef }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);

  const [selectedImages, setSelectedImages] = useState([]);
  const captionRef = useRef(null);
  // const { id } = useParams();
  const { id } = useParams();
  const uploadPost = async () => {
    // const siteRef = firestore.doc(`sites/${id}`);

    //  firebase.firestore().collection("sites").doc(id);
    const docRef = await addDoc(
      // collection(firestore, `sites/Qe1BUcifbRpaP0QZl8iO/files`),
      collection(firestore, `sites/${id}/files`),

      //   // .doc("Qe1BUcifbRpaP0QZl8iO")
      //   .doc(this.props.user.uid)
      //   .collection("files"),
      // onCreate(selectedImages),
      {
        caption: captionRef.current.value,
        timestamp: serverTimestamp(),
      }
    );
    await Promise.all(
      selectedImages.map((image) => {
        const imageRef =
          image.type === "application/pdf"
            ? ref(storage, `files/pdf/${docRef.id}/${image.path}`)
            : image.type === "application/msword"
            ? ref(storage, `files/doc/${docRef.id}/${image.path}`)
            : image.type ===
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            ? ref(storage, `files/doc/${docRef.id}/${image.path}`)
            : ref(storage, `files/${docRef.id}/${image.path}`);
        uploadBytes(imageRef, image, "data_url").then(async () => {
          const downloadURL = await getDownloadURL(imageRef);
          await updateDoc(
            // doc(firestore, "sites/Qe1BUcifbRpaP0QZl8iO/files", docRef.id),
            doc(firestore, `sites/${id}/files`, docRef.id),
            {
              images: arrayUnion(downloadURL),
            }
          );
        });
      })
    );
    captionRef.current.value = "";
    setSelectedImages([]);
  };

  const onDrop = useCallback((acceptedFiles) => {
    setSelectedImages(
      acceptedFiles.map((file) =>
        file.type === "application/pdf"
          ? Object.assign(file, {
              preview:
                "https://cdn3.iconfinder.com/data/icons/dompicon-flat-file-format/256/file-pdf-format-type-512.png",
            })
          : file.type === "application/msword"
          ? Object.assign(file, {
              preview:
                "https://cdn3.iconfinder.com/data/icons/muksis/128/doc-1024.png",
            })
          : file.type ===
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          ? Object.assign(file, {
              preview:
                "https://cdn3.iconfinder.com/data/icons/muksis/128/doc-1024.png",
            })
          : Object.assign(file, { preview: URL.createObjectURL(file) })
      )
    );

    // onCreate(isLoading);
    // const file = acceptedFiles?.[0];

    // if (!file) {
    //   return;
    // }

    // setIsLoading(true);
    // setError(null);
    // setMessage(null);

    // try {
    //   await uploadFromBlobAsync({
    //     blobUrl: URL.createObjectURL(file),
    //     name: `${file.name}_${Date.now()}`,
    //   });
    // } catch (e) {
    //   setIsLoading(false);
    //   // setError(e.message);
    //   toast.error(`${e.message}`, {
    //     theme: "colored",
    //   });

    //   return;
    // }

    // setIsLoading(false);
    // // setMessage("File was uploaded");
    // toast.success("File(s) was uploaded", {
    //   theme: "colored",
    // });
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
  const selected_images = selectedImages?.map((file) => (
    <>
      <img src={file.preview} style={{ width: "200px" }} alt="" />
    </>
  ));

  return (
    <>
      <Box
        sx={{
          p: 4,
          height: "7em",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          marginBottom: "30px",
          border: (theme) =>
            theme.palette.mode === "dark"
              ? "dashed 2px #17629A"
              : "dashed 2px #00BFC6",
        }}
        {...getRootProps()}
      >
        <input {...getInputProps()} />

        {isLoading ? (
          <CircularProgress />
        ) : isDragActive ? (
          <Typography>Drop the files here...</Typography>
        ) : (
          <Typography>
            Drag 'n' drop some files here, or click to select files
          </Typography>
        )}
        {(error || message) && <Typography>{error || message}</Typography>}
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}></Grid>
        <Grid item xs={12} md={6} align="right">
          <TextField
            className="file-caption"
            inputRef={captionRef}
            type="text"
            placeholder="Enter a caption"
            sx={{
              width: {
                xs: "100%",
                sm: "auto",
              },
            }}
          />

          <Button
            sx={{
              m: 1,
              ml: {
                xs: 0,
                sm: 3,
              },
              width: {
                xs: "100%",
                sm: "auto",
              },
            }}
            variant="contained"
            size="medium"
            onClick={uploadPost}
          >
            Upload
          </Button>
        </Grid>
      </Grid>

      <Box>{selected_images}</Box>
    </>
  );
};

export default UploadFiles3;
